import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_ENTERPRISES_START, PUT_ENTERPRISES_ERROR, PUT_ENTERPRISES_START, PUT_ENTERPRISES_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* edit({ payload }) {
  try {
    const url = `/enterprises/update/${payload.id}`;
    const method = 'PUT';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: PUT_ENTERPRISES_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: PUT_ENTERPRISES_ERROR, error });
  } finally {
    yield put({ type: GET_ENTERPRISES_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* put_enterprises() {
  yield takeLatest(PUT_ENTERPRISES_START, edit);
}

